import { TableContainer } from "@material-ui/core";
import FilterTabs from "components/filterTabs/FilterTabs";
import CircularProgress from "@mui/material/CircularProgress";
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import React, { useEffect, useState } from "react";
import ExpandableRow from "./expandTableDeposits";

import { useAuth0 } from "@auth0/auth0-react";
import { IconButton } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Pagination from "@material-ui/lab/Pagination";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Paper from "@mui/material/Paper";
import { ReactComponent as Sort } from "assets/icons/Sort.svg";
import { MyCheckbox } from "components";
import Button from "components/button/Button";
import AlertDialog from "components/Dialog/index";
import MainDialog from "components/Dialog/MainDialog";
import RightDrawer from "components/drawer";
import Loader from "components/loader/Loader";
import FinanceService from "Lib/API/Finance";
import "react-date-range/dist/theme/default.css"; // theme css file
import { BsSortDown } from "react-icons/bs";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import Select from "react-select";
import styled from "styled-components";
import FinanceSettingService from "../../../../Lib/API/FinanceSetting/FinanceSetting";
import { CheckFloatValue } from "../../../../utils/functions";
import FinanceDrawer from "../../Drawer";
import "./styles.scss";

const TypeBox = styled.div`
  display: flex;
  justify-content: space-between;
  > :nth-child(1) {
    background-color: #e7edf9;
    width: max-content;
    border-radius: 4px;
    margin-bottom: 41px;
  }
  > :nth-child(2) {
  
  }
  > :nth-child(3) {
   
  }
`;
const SortSvg = styled(Sort)`
  margin-left: 10px;
  cursor: pointer;
  margin-bottom: 4px;
`;
const CreateBatch = styled.button`
  &:disabled {
    background: #e7e7eb !important;
    border-radius: 5px !important;
    cursor: not-allowed;
    width: 111px;

    border: none;
    color: #acacac !important;
    > i {
      color: "#acacac";
    }
  }
  color: #ffff !important;
  height: 48px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px !important;
  width: 111px !important;
  background-color: #2555ef !important;
`;
const Success = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  background: #4caf50;
  border-radius: 6px;
  max-width: 284px;
  height: 36px;
  color: #ffffff;
  width: 284px;
  justify-content: space-evenly;
  flex-direction: row;
`;
const SelectedData = styled.div`
  display: flex;
  justify-content: space-between;
  width: 23rem;
  margin-bottom: 25px;
  > span {
    font-weight: 700;
    color: #4f4f4f;
    > label {
      font-weight: 500;
    }
  }
`;
const SpanHeader = styled.span`
  /* font-weight: 500; */
  font-size: 12px;
  line-height: 18px;
`;
export const DepositsTabel = ({
  filters,
  sortCharged,
  batch_id,
  switchType,
  type,
  setFilters,
  page,
  setPage,
  goFilter,
  setIsLoading,
  isLoading
}) => {
  const selectedBatch_Id = useSelector((state) => state.homeReducer.selectedBatch_Id);

  const [openModal, setOpenModal] = React.useState(false);
  const [isSucsess, setIsSucsess] = React.useState(false);
  const [drawerData, setDrawerData] = useState({});
  const [ChargesCheck, setChargesCheck] = useState([]);
  const [selectedAmount, setSelectedAmount] = useState([]);
  const [rawArrayDeposit, setRawArrayDeposit] = useState([]);
  const [totalDeposite, setTotalDeposit] = useState(null);
  const [openAlert, setOpenAlert] = useState(false);

  const [PaymentsCheck, setPaymentsCheck] = useState([]);
  const [check, setCheck] = useState([]);
  const [allCheck, setAllCheck] = useState(false);
  const [defaultPage, setDefaultPage] = useState(-1);
  const [allData, setAllData] = useState([]);

  const [paymentMethods, setPaymentMethods] = useState([]);
  const [amount, setAmount] = useState(0);
  const { getAccessTokenSilently } = useAuth0();
  const [productData, setProductData] = useState([]);
  const [count, setCount] = useState();
  const [rowsPerPage, setRowsPerPage] = React.useState(30);
  const [checkPage, setCheckPage] = useState([]);
  const [bank_account, setBankAccount] = useState("");
  const [isCountLoading, setIsCountLoading] = useState(false);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [confirmClose, setConfirmClose] = useState(false);


  const storageData = JSON.parse(
    localStorage.getItem("organization") !== "undefined"
      ? localStorage.getItem("organization")
      : "{}"
  );

  useEffect(() => {
    if (storageData?.quickBooks_information?.accountType === "cash") {
      switchType("payment");
    }
  }, [storageData]);

  useEffect(() => {
    if (openAlert) {
      setStartDate("");
      setSelectedBank(null);
    }
  }, [openAlert]);

  const [bankAccountList, setBankAccountList] = useState([]);
  const [selected, setSelected] = useState("");

  const [listarray, setListArray] = useState([]);
  const [PaymentData, setPaymentData] = useState([]);

  useEffect(() => {
    if (bankAccountList?.length > 0) {
      const data = bankAccountList?.map((item) => {
        setListArray((prev) => [
          ...prev,
          { label: item?.title, value: item?._id },
        ]);
      });
    }
  }, [bankAccountList]);

  const getDepositsApiHandler = async () => {
    try {
      setIsLoading(true);
      if (filters?.filter?.amount === "") {
        delete filters?.filter?.amount;
      }
      if (filters?.search === "") {
        delete filters?.search;
      }
      if (filters?.filter?.paid_at === "") {
        delete filters?.filter?.paid_at;
      }
      if (filters?.filter?.charge_date === "") {
        delete filters?.filter?.charge_date;
      }
      const token = await getAccessTokenSilently();
      if (batch_id) {
        FinanceService.ViewBatchPayment(token, page + 1, 30, {
          filter: {
            batch_billing: selectedBatch_Id?.type === "batch" ? selectedBatch_Id?.data : batch_id,
          },
        })
          .then((res) => {
            const result = res?.payload?.data;
            setProductData(result);
            setChargesCheck([]);
            setSelectedAmount([]);
            setPaymentsCheck([]);
            setCheck([]);
            setAmount(0);
            setCount(res?.payload?.pagination?.count);
          })
          .catch((err) => {
            toastr.error("Error", err?.data?.message);
          });
        return;
      }

      const selectedFilter = filters;
      if (
        selectedType === false &&
        storageData?.quickBooks_information?.accountType === "cash"
      ) {
        selectedFilter["status"] = "payment";
      }
      if (
        selectedType === false &&
        storageData?.quickBooks_information?.accountType !== "cash"
      ) {
        selectedFilter["status"] = "charge";
      }
      if (selectedType) {
        selectedFilter["status"] = type;
      }

      if (type === "charge" && storageData?.quickBooks_information?.accountType !== "cash") {
        const filterdata = {
          search: filters?.search,
          filter: {
            syncedBatch: true,
            showZero: false,
            method: filters?.filter?.method,
            amount: filters?.filter?.amount,
            ledger: filters?.filter?.ledger,
            subLedger: filters?.filter?.subLedger,
            paid_at: filters?.filter?.paid_at,
            charge_date: filters?.filter?.charge_date,
          },
          sort: filters?.sort,
        };
        await FinanceService.getAllTransactionsEnhance(
          token,
          page + 1,
          30,
          filterdata
        ).then((res) => {
          const result = res?.payload?.data;
          setRawArrayDeposit([
            ...rawArrayDeposit,
            {
              page: res?.payload?.pagination?.current_page,
              data: res?.payload?.data,
              type: type,
            },
          ]);
          let mapData = result.map((item) => {
            return item;
          });
          setProductData(result);
          setAllData([...allData, mapData]);
          setHasNextPage(res?.payload?.pagination?.hasNextPage);
          setIsLoading(false);
        });
      } else {
        const filterdata = {
          search: filters?.search,
          filter: {
            method: filters?.filter?.method,
            amount: filters?.filter?.amount,
            ledger: filters?.filter?.ledger,
            subLedger: filters?.filter?.subLedger,
            paid_at: filters?.filter?.paid_at,
          },
          sort: filters?.sort,
        };

        await FinanceService.getPaymentTransactionsForDepositEnhance(
          token,
          page + 1,
          30,
          filterdata
        ).then((res) => {
          const result = res?.payload?.data;
          setRawArrayDeposit([
            ...rawArrayDeposit,
            {
              page: res?.payload?.pagination?.current_page,
              data: res?.payload?.data,
              type: type,
            },
          ]);

          let mapData = result.map((item) => {
            return item;
          });

          setProductData(result);
          if (PaymentsCheck?.length === 0) {
            setPaymentData(result);
          } else {
            setPaymentData(PaymentData.concat(result));
          }
          setAllData(mapData);

          setHasNextPage(res?.payload?.pagination?.hasNextPage);
          setIsLoading(false);
        });
      }
    } catch (e) {
      setIsLoading(false);
      toastr.error("Error", e?.data?.message);
    }
  };

  const fetchCount = async () => {
    try {
      setIsCountLoading(true);
      const token = await getAccessTokenSilently();
      if (type === "charge" && storageData?.quickBooks_information?.accountType !== "cash") {
        const filterdata = {
          search: filters?.search,
          filter: {
            syncedBatch: true,
            showZero: false,
            method: filters?.filter?.method,
            amount: filters?.filter?.amount,
            ledger: filters?.filter?.ledger,
            subLedger: filters?.filter?.subLedger,
            paid_at: filters?.filter?.paid_at,
            charge_date: filters?.filter?.charge_date,
          },
          sort: filters?.sort,
        };
        const res = await FinanceService.getTransactionsCount(token, 1, 30, filterdata);
        setCount(res?.payload?.pagination?.count);
      } else {
        const filterdata = {
          search: filters?.search,
          filter: {
            method: filters?.filter?.method,
            amount: filters?.filter?.amount,
            ledger: filters?.filter?.ledger,
            subLedger: filters?.filter?.subLedger,
            paid_at: filters?.filter?.paid_at,
          },
          sort: filters?.sort,
        };
        const res = await FinanceService.getPaymentTransactionsForDepositCount(token, page + 1, 30, filterdata);
        setCount(res?.payload?.pagination?.count);
      }
    } catch (e) {
      toastr.error("Error", e?.data?.message);
    } finally {
      setIsCountLoading(false);
    }
  }

  useEffect(() => {
    fetchCount();
  }, [type, goFilter, filters?.filter?.method]);

  const allDataSet = new Set(allData.flat());
  const allDataArray = [...allDataSet].sort((a, b) => a - b);

  var AllProductData = [];

  allDataArray.filter(function (item) {
    var i = type === "charge" ? AllProductData.findIndex((x) => x.charge?._id == item?.charge?._id) : AllProductData.findIndex((x) => x._id == item._id);
    if (i <= -1) {
      AllProductData.push(item);
    }
    return null;
  });

  const [start_date, setStartDate] = useState("");
  const [selectedBank, setSelectedBank] = useState(null);

  const handleBankChange = (selectedOption) => {
    setSelectedBank(selectedOption);
  };

  const handleSelect = (dates) => {
    setStartDate(dates);
  };

  const createNewBatch = async () => {
    setIsLoading(true);
    try {
      const body = {
        type: type,
        // date: moment(start_date).format("MM/DD/YYYY"),
      };
      if (type === "payment") {
        body["bank_account"] = {
          id: selectedBank?.value,
          title: selectedBank?.label,
        };
        body["transactions"] = PaymentsCheck;
      } else {
        body["transactions"] = ChargesCheck;
      }
      const token = await getAccessTokenSilently();
      await FinanceService.creatNewbatch(token, body).then((res) => {
        setStartDate("");
        setSelectedBank(null);
        setOpenAlert(false);
        setIsLoading(false);
        setChargesCheck([]);
        setSelectedAmount([]);
        setPaymentsCheck([]);
        setCheck([]);
        setAmount(0);
        getDepositsApiHandler();
        setIsSucsess(true);
        setTimeout(() => {
          setIsSucsess(false);
        }, 3000);
      });
    } catch (e) {
      setIsLoading(false);
      toastr.error("Error", e?.data?.message || "Something went wrong");
    }
  };

  /**
   * @param {React.ChangeEvent<HTMLInputElement>} e
   * @param {string} accountId
   */
  useEffect(() => {
    getDepositsApiHandler();
  }, [filters?.filter?.method, type, page, filters?.sort, goFilter]);

  useEffect(() => {
    getPaymentMethods();
  }, []);

  useEffect(() => {
    // setAmount(0);
    // setPaymentsCheck([]);
    // setChargesCheck([]);
  }, [type]);
  const [newArray, setNewArr] = useState([]);

  const onCheckboxChange = (e, row, all = false) => {
    const { checked } = e.target;

    let allAmount = 0;
    if (row.length > 1) {
      row.map((item) => {
        allAmount =
          type === "charge"
            ? allAmount + item?.charge?.amount
            : allAmount + item?.charge?.payment?.History?.amount;
      });
    }

    if (all === false) {
      const id =
        type === "charge"
          ? row?.charge?._id
          : row?.charge?.payment?.History?._id;
      if (!checked) {
        if (type === "charge") {
          setAmount(amount - row?.charge?.amount);
        }
        if (type === "payment") {
          setAmount(amount - row?.charge?.payment?.History?.amount);
        }

        if (type === "charge") {
          setChargesCheck((prev) => {
            const checkClone = prev.filter((item) => item !== id);
            return [...checkClone];
          });
        } else {
          setPaymentsCheck((prev) => {
            const checkClone = prev.filter((item) => item !== id);
            return [...checkClone];
          });
        }
        return;
      } else {
        setAmount(amount + row?.charge?.amount);
        setCheck((prev) => [...prev, id]);

        if (type === "charge") {
          setChargesCheck((prev) => [...prev, id]);
        } else {
          setPaymentsCheck((prev) => [...prev, id]);
        }
      }
    } else {
      if (!checked) {
        if (newArray.length > 1) setNewArr((newArray.length = 0));

        setNewArr(newArray.filter((item) => item !== allAmount));

        let CheckAmount = amount;
        if (type === "charge") {
          productData.forEach((ele) => {
            const id = ele?.charge?._id;
            if (PaymentsCheck.includes(id)) {
              CheckAmount -= ele?.charge?.amount;
            }
          });

          if (type === "charge") {
            const data = row.map((check) => {
              return check?.charge?._id;
            });

            const result = ChargesCheck.filter(function (obj) {
              return data.indexOf(obj) == -1;
            });
            setChargesCheck([]);
            setChargesCheck(result);
          }
        } else if (type === "payment") {
          const data = row.map((check) => {
            return check?.charge?.payment?.History?._id;
          });
          const result = PaymentsCheck.filter(function (obj) {
            return data.indexOf(obj) == -1;
          });

          setPaymentsCheck(result);
        }
        setAmount(CheckAmount);
      } else {
        let tempAmount = amount;
        row.map((ele) => {
          const id =
            type === "charge"
              ? ele?.charge?._id
              : ele?.charge?.payment?.History?._id;
          const amount =
            type === "charge"
              ? ele?.charge?.amount
              : ele?.charge?.payment?.History?.amount;

          if (!check.includes(id)) {
            tempAmount += ele?.charge?.amount;
            setCheck((prev) => [...prev, id]);
          }
          if (type === "charge") {
            if (!ChargesCheck.includes(id)) {
              tempAmount += ele?.charge?.amount;

              setChargesCheck((prev) => [...prev, id]);
              setSelectedAmount((prev) => [...prev, amount]);
            }
          } else if (type === "payment") {
            if (!PaymentsCheck.includes(id)) {
              tempAmount += ele?.charge?.payment?.History?.amount;
              setPaymentsCheck((prev) => [...prev, id]);
              setSelectedAmount((prev) => [...prev, amount]);
            }
          }
        });

        setTotalDeposit(tempAmount);
        setTotalDeposit(allAmount);
        setNewArr((prev) => [...prev, allAmount]);
      }
    }
  };
  const [PaymentsCheckTotal, setPaymentsCheckTotal] = useState(0);
  const [ChargesCheckTotal, setChargesCheckTotal] = useState(0);

  useEffect(() => {
    // setPaymentsCheckTotal(0);
    // setPaymentData([]);
    // setPaymentsCheck([]);
    setPage(0);
  }, [filters?.filter?.method, goFilter])


  useEffect(() => {
    let chargeNum = 0;
    let peyNum = 0;

    if (ChargesCheck.length == 0) {
      setChargesCheckTotal(0);
    } else {
      AllProductData.map((item) => {
        if (ChargesCheck.includes(item?.charge?._id)) {
          setChargesCheckTotal((chargeNum += item?.charge?.amount));
        }
      });
    }

    // console.log(PaymentData, "PaymentData", PaymentsCheck);

    if (PaymentsCheck.length == 0 && type !== "charge") {
      // setPaymentsCheckTotal(0);
      // setPaymentData([]);
      // getDepositsApiHandler();
    } else {

      // const uniqueData = Array.from(new Set(PaymentData));
      const uniqueData = PaymentData.reduce((acc, obj) => {
        acc[obj.charge?.payment?.History?._id] = obj;
        return acc;
      }, {});
      const result = Object.values(uniqueData);

      // const response = PaymentData.concat(result)

      // const filteredArray = result.filter(newObj => !PaymentData.find(oldObj => oldObj._id === newObj._id));

      // console.log("filteredArrayfilteredArray", filteredArray)

      result.map((item) => {
        if (PaymentsCheck.includes(item?.charge?.payment?.History?._id)) {
          setPaymentsCheckTotal(
            (peyNum += item?.charge?.payment?.History?.amount)
          );
        }
      });
    }
  }, [ChargesCheck, PaymentsCheck]);

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
    setDefaultPage(newPage);
    setFilters({ ...filters });
  };

  useEffect(() => {
    console.log(ChargesCheckTotal, "ChargesCheckTotal")
    let total = type === "charge" ? ChargesCheckTotal : PaymentsCheckTotal;

    setTotalDeposit(total);
  }, [ChargesCheckTotal, PaymentsCheckTotal, ChargesCheck, PaymentsCheck]);

  const getCommaSeperatedValue = (num) => {
    return (
      CheckFloatValue(num)
        ?.toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",") ?? 0.0
    );
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const getPaymentMethods = async () => {
    const token = await getAccessTokenSilently();
    const res = await FinanceService.getPaymentMethods(token);
    if (res?.result) {
      setPaymentMethods(res?.result);
    }
  };

  useEffect(() => {
    const mathvalue = 30;
    if (ChargesCheck?.length >= mathvalue && type === "charge") {
      setGettingValues(
        rawArrayDeposit?.map((data) => {
          if (data?.type === type) {
            if (data.page === page + 1) {
              return setBooleanValue(
                data.data.length === productData.length &&
                ChargesCheck.length >= mathvalue * (page + 1)
              );
            } else {
              return true;
            }
          }
        })
      );
    } else if (PaymentsCheck?.length >= mathvalue && type === "payment") {
      setGettingValues(
        rawArrayDeposit?.map((data) => {
          if (data?.type === type) {
            if (data.page === page + 1) {
              return setBooleanValue(
                data.data.length === productData.length &&
                PaymentsCheck?.length >= mathvalue * (page + 1)
              );
            }
            return false;
          }
        })
      );
    } else {
      return setBooleanValue(false);
    }
  }, [type, ChargesCheck, rawArrayDeposit, productData, PaymentsCheck]);

  // useEffect(() => {
  //   setFilters({
  //     filter: {
  //       // charge_type: "charge",
  //       syncedBatch: true,
  //       method: "all",
  //       paid_at: "",
  //     },

  //     status: filters.status,
  //   });
  // }, [filters.status]);

  useEffect(() => {
    fetchBankAccountList();
  }, []);

  // Get Bank Account List
  const fetchBankAccountList = async () => {
    const token = await getAccessTokenSilently();
    await FinanceSettingService.getBankAccountList(token)
      .then((res) => {
        setBankAccountList(res?.result.reverse());
        setSelected(res?.result[0]?.title);
        setBankAccount(res?.result[0]);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
  };

  const onTypeClick = (type, id) => {
    // getTypeId(type, id);
    setBankAccount(type);
    setSelected(type?.title);
  };

  const [gettingValues, setGettingValues] = useState([]);
  const [booleanValue, setBooleanValue] = useState(false);

  const handleCheck = () => {
    setAllCheck(!allCheck);
    if (checkPage.includes(page)) {
      let newChecks = checkPage.filter((item) => {
        return item !== page;
      });
      setCheckPage(newChecks);
    } else {
      setCheckPage((prev) => [...prev, page]);
    }
  };

  useEffect(() => {
    setChargesCheck([]);
    setPaymentsCheck([]);
    setAmount(0);
    setTotalDeposit(0);
    setCheckPage([]);
  }, [filters?.status]);

  const [selectedType, setSelectedType] = useState(false);


  const closeModal = () => {
    setConfirmClose(true);
  }
  const confirmCloseHandler = () => {
    setConfirmClose(false);
    setOpenAlert(false);
   
  }


  return (
    <div className="w-100">
      {type === "payment" && paymentMethods.length > 0 && (
        <div className="mb-3" style={{ paddingLeft: "28px" }}>
          <FilterTabs
            tabs={[{ title: "All", value: "all" }, ...paymentMethods.map((e) => ({ title: e.type, value: e.type }))]}
            activeTab={filters?.filter?.method ?? "all"}
            onTabsChange={(tab) => setFilters((prev) => ({ ...prev, filter: { ...prev.filter, method: tab.value } }))}
            style={{ flexWrap: "wrap", rowGap: "8px" }}
          />
        </div>
      )}
      <div className="family-table-container p-7 pb-15">
        <div className="home-table-container mt-0 no-box-shadow">
          <TypeBox>
            <div
              className="d-flex align-items-center"
              style={{
                height: "36px",
                backgroundColor: "#e7edf9",
                borderRadius: "4px",
              }}
            >
              {storageData?.quickBooks_information?.accountType !== "cash" && (
                <button
                  type="button"
                  onClick={() => {
                    setSelectedType(true);
                    switchType("charge");
                    setPage(0);

                    setFilters({
                      filter: {
                        syncedBatch: true,
                        method: "all",
                        paid_at: "",
                        amount: "",
                      },
                      search: "",
                      status: "charge",
                    });
                  }}
                  className="d-flex align-items-center font-weight-bold"
                  style={{
                    height: "24px",
                    margin: "0 4px",
                    padding: "0 10px",
                    borderRadius: "4px",
                    border: "none",
                    outline: "none",
                    boxShadow: "none",
                    cursor: "pointer",
                    fontSize: "13px",
                    background: type === "charge" ? "#2555EF" : "transparent",
                    color: type === "charge" ? "#FFFFFF" : "#2555EF",
                  }}
                >
                  Charges
                </button>
              )}
              <button
                type="button"
                onClick={() => {
                  switchType("payment");
                  setSelectedType(true);
                  setPage(0);

                  setFilters({
                    filter: {
                      method: "all",
                      paid_at: "",
                      amount: "",
                    },
                    search: "",
                    // status: "payment",
                  });
                }}
                className="d-flex align-items-center font-weight-bold"
                style={{
                  height: "24px",
                  margin: "0 4px",
                  padding: "0 10px",
                  borderRadius: "4px",
                  border: "none",
                  outline: "none",
                  boxShadow: "none",
                  cursor: "pointer",
                  fontSize: "13px",
                  background: type === "payment" ? "#2555EF" : "transparent",
                  color: type === "payment" ? "#FFFFFF" : "#2555EF",
                }}
              >
                Payments
              </button>
            </div>
            {isSucsess && (
              <Success>
                <CheckCircleOutlineIcon />
                <span>Batch Created Successfully</span>
              </Success>
            )}
            <Button
              type="button"
              variant="primary"
              size="md"
              onClick={() => {
                if (type === "payment") {
                  setOpenAlert(true);
                } else {
                  createNewBatch();
                }
              }}
              disabled={
                !(PaymentsCheck?.length > 0 || ChargesCheck?.length > 0)
              }
              style={{
                minWidth: "100px",
              }}
            >
              <PlusIcon />
              Batch
            </Button>
          </TypeBox>

          <TableContainer component={Paper} className="scroll-table">
            <>
              {(PaymentsCheck?.length > 0 || ChargesCheck?.length > 0) && (
                <SelectedData style={{ minWidth: "335px" }}>
                  <span>
                    {" "}
                    {PaymentsCheck?.length + ChargesCheck?.length}{" "}
                    <label> transactions selected </label>
                  </span>
                  <span>
                    <label> Total Amount:</label>{" "}
                    {totalDeposite && getCommaSeperatedValue(totalDeposite)}
                  </span>
                </SelectedData>
              )}
              <Table
                className={`${isLoading === true ? "d-flex flex-column" : ""}`}
              >
                <TableHead className="main-table__header sticky-table-header">
                  <TableRow>
                    {type !== "Deposited" && (
                      <TableCell padding="checkbox" className="main-check">
                        {type === "charge" ? (
                          <MyCheckbox
                            color="default"
                            handlechange={(e) => {
                              onCheckboxChange(
                                e,
                                productData,
                                true,
                                ChargesCheck
                              );
                              handleCheck();
                            }}
                            checked={checkPage?.includes(page) ? true : false}
                          />
                        ) : (
                          <MyCheckbox
                            color="default"
                            handlechange={(e) => {
                              onCheckboxChange(
                                e,
                                productData,
                                true,
                                PaymentsCheck
                              );
                              handleCheck();
                              setAllCheck(!allCheck);
                            }}
                            checked={checkPage?.includes(page) ? true : false}
                          />
                        )}
                      </TableCell>
                    )}
                    <TableCell style={{ width: "90px" }} />
                    <TableCell style={{ width: "150px" }}>
                      {type === "charge" ? "CREATED DATE" : "PAYMENT DATE"}
                      <IconButton>
                        {type === "charge" ? (
                          filters?.sort?.tran_date === 1 ? (
                            <BsSortDown onClick={() => sortCharged("tran_date")} />
                          ) : (
                            <SortSvg onClick={() => sortCharged("tran_date")} />
                          )
                        )
                          : filters?.sort?.paymentDate === 1 ? (
                            <BsSortDown onClick={() => sortCharged("paymentDate")} />
                          ) : (
                            <SortSvg onClick={() => sortCharged("paymentDate")} />
                          )
                        }
                      </IconButton>
                    </TableCell>
                    <TableCell style={{ width: "150px" }}>
                      {"DUE DATE"}
                      {type === "charge" ? (
                        <IconButton>
                          {filters?.sort?.due_date === 1 ? (
                            <BsSortDown onClick={() => sortCharged("due_date")} />
                          ) : (
                            <SortSvg onClick={() => sortCharged("due_date")} />
                          )
                          }
                        </IconButton>
                      ) : (
                        <IconButton>
                          {filters?.sort?.dueDate === 1 ? (
                            <BsSortDown onClick={() => sortCharged("dueDate")} />
                          ) : (
                            <SortSvg onClick={() => sortCharged("dueDate")} />
                          )}
                        </IconButton>
                      )
                      }
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{ width: "310px" }}
                      className="deposits-accountname-cell"
                    >
                      <SpanHeader>{"Account Name".toUpperCase()}</SpanHeader>
                      <IconButton>
                        {filters?.sort?.account_name === 1 ? (
                          <BsSortDown onClick={() => sortCharged("account_name")} />
                        ) : (
                          <SortSvg onClick={() => sortCharged("account_name")} />
                        )
                        }
                      </IconButton>
                    </TableCell>
                    {/* <TableCell align="left" style={{ width: "155px" }}>
                      <SpanHeader>Type</SpanHeader>
                    </TableCell> */}
                    <TableCell align="left" style={{ width: "155px" }}>
                      <SpanHeader>AMOUNT</SpanHeader>
                    </TableCell>
                    {type === "payment" && (
                      <TableCell align="left" style={{ width: "330px" }}>
                        <SpanHeader>BULK AMOUNT</SpanHeader>
                      </TableCell>
                    )}
                    {type === "payment" && (
                      <TableCell style={{ width: "90px" }}>
                        PAYMENT METHOD
                      </TableCell>
                    )}
                    <TableCell align="left" style={{ width: "330px" }}>
                      <SpanHeader>SUB LEDGER / LEDGER</SpanHeader>
                    </TableCell>
                    <TableCell align="left" style={{ width: "220px" }}>
                      <SpanHeader>
                        {" "}
                        {type === "charge" ? "TRANSACTION#" : "PAYMENT#"}
                      </SpanHeader>
                    </TableCell>
                  </TableRow>
                </TableHead>
                {isLoading && (
                  <div
                    className="w-100 h-100 d-flex justify-content-center align-items-center"
                    style={{ marginBottom: "11rem" }}
                  >
                    <Loader />
                  </div>
                )}

                {isLoading === false && (
                  <>
                    {productData?.length === 0 ? (
                      <td colSpan={12}>
                        <div className="record-text">No record found</div>
                      </td>
                    ) : (
                      productData?.map((row) => (
                        <TableBody>
                          <ExpandableRow
                            key={row.name}
                            row={row}
                            onCheckboxChange={onCheckboxChange}
                            check={page === defaultPage && check}
                            setDrawerData={setDrawerData}
                            setOpenModal={setOpenModal}
                            filters={filters}
                            type={type}
                            PaymentsCheck={PaymentsCheck}
                            ChargesCheck={ChargesCheck}
                            productData={productData}
                          />
                        </TableBody>
                      ))
                    )}
                  </>
                )}
              </Table>
            </>
          </TableContainer>
          {isCountLoading && page === 0 ? (
            <div class="pagination-custom mt-2 align-items-center">
              <div class="arrow_btn">&#8249;</div>
              <CircularProgress size={18} className="mx-5" />
              <div class="arrow_btn">&#8250;</div>
            </div>
          ) : productData?.length === 0 ? (
            ""
          ) : (
            <div className="pagination-custom mt-2">
              <div>
                <Pagination
                  count={Math.ceil(count / 30)}
                  color="primary"
                  page={page + 1}
                  variant="outlined"
                  onChange={(event, value) => {
                    setPage(value - 1);
                  }}
                  hideNextButton={!hasNextPage}
                />
              </div>
            </div>
          )
          }
        </div>
        <RightDrawer
          open={openModal}
          onClose={() => {
            setOpenModal(false);
          }}
        >
          <FinanceDrawer
            data={drawerData}
            handleClose={() => setOpenModal(false)}
          />
        </RightDrawer>
      </div>
      <MainDialog
        open={openAlert}
        handleClose={closeModal}
        onDecline={closeModal}
        onAccept={() => {
          createNewBatch();
        }}
        okButtonContent={"Ok"}
        content={
          type === "charge"
            ? "Date of charge batch"
            : type === "payment"
              ? "Select a Bank Account"
              : ""
        }
        subContent={
          <div
            style={{
              minHeight: "180px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {(type === "payment" || type === "charge") && (
              <>
                {/* <div
                  style={{
                    width: type === "payment" ? "250px" : "100%",
                  }}
                >
                  <ReactDatePicker
                    {...{
                      // formik,
                      title: "Date Range",
                      name: `date_range`,
                    }}
                    // onChange={handleSelect}
                    // startDate={start_date ?? ""}
                    // endDate={end_date ?? ""}
                    selected={start_date}
                    onChange={handleSelect}
                    // selectsRange
                    placeholderText={"Select Date"}
                    className="date-picker-custom new-batch-daterange"
                  />
                </div> */}
                {type === "payment" ? (
                  <div
                    className="ml-2"
                    style={{
                      width: "250px",
                    }}
                  >
                    {/* <h4
                      style={{
                        textAlign: "left",
                        fontSize: "16px",
                        fontWeight: "400",
                        color: "black",
                        wordSpacing: "4px",
                        // padding: "0px 30px",
                        fontFamily: "poppins",
                      }}
                    >
                      Bank Account
                    </h4> */}
                    <div className="bank_list">
                      <Select
                        value={selectedBank}
                        placeholderText={"Select Bank Account"}
                        onChange={handleBankChange}
                        options={listarray}
                      />
                    </div>
                    {/* {bankAccountList?.map((item, index) => (
                      <div
                        key={index}
                        style={{
                          fontSize: "14px",
                          fontWeight: "400",
                          color: "black",
                          wordSpacing: "4px",
                          padding: "0px 30px",
                          fontFamily: "poppins",
                        }}
                        className={
                          selected === item.title
                            ? "type-select p-5 bg-white text-dark left-menu-items selectedbankAccount text-start"
                            : "p-5 bg-white text-dark left-menu-items cursor-pointer text-start bg-gray"
                        }
                        onClick={() => onTypeClick(item)}
                      >
                        {item?.title ?? item?.type}
                        <span style={{ color: "grey", marginLeft: "50px" }}>
                          {item?.is_default === true ? "Default" : ""}
                        </span>
                      </div>
                    ))} */}
                  </div>
                ) : (
                  <></>
                )}
              </>
            )}
          </div>
        }
      />
      <AlertDialog
        open={confirmClose}
        onDecline={() => {
          setConfirmClose(false);
        }}
        onAccept={confirmCloseHandler}
        title={"Are you sure?"}
        description={"Do you want to discard the changes you made?"}
      />
    </div>
  );
};